var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Breadcrumb", { attrs: { dataSource: _vm.breadcrumbList } }),
      _c("AbnormalFeedback", {
        attrs: { tabPaneConfig: _vm.tabPaneConfig },
        on: { viewDetail: _vm.viewFeedbackDetail },
      }),
      _c("AbnormalStudentScreening", {
        attrs: { tabPaneConfig: _vm.tabPaneConfig },
        on: { viewDetail: _vm.viewScreeningDetail },
      }),
      _c("NotCollectedDetailModal", {
        ref: "notCollectedDetailModalRef",
        attrs: { tabKey: _vm.tabKey },
      }),
      _c("FeedbackDetailModal", { ref: "feedbackDetailModalRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }